export const ONE_MINUTE = 1000 * 60;
export const ONE_DAY = 1000 * 60 * 60 * 24;

export const addSeconds = (date, seconds) => {
  date.setSeconds(date.getSeconds() + seconds);
  return date.toISOString();
};

export const adjustDateWithOffset = timezoneOffset => {
  const newDate = new Date();
  const utc = newDate.getTime() + newDate.getTimezoneOffset() * 60000;
  const adjustedDate = new Date(utc + timezoneOffset);
  return adjustedDate;
};
